export default __webpack_public_path__ + "static/media/laptop10.915d2c77.jpeg";